import styled from "styled-components";
import { Details_DetailsType } from "@smartsuite/automation-engine-api";

export const getBackgroundColor = (
  detailsType: Details_DetailsType,
): string => {
  if (detailsType === Details_DetailsType.INFO) {
    return "rgba(250, 250, 250, 1)";
  }

  if (detailsType === Details_DetailsType.WARNING) {
    return "rgba(255, 242, 220, 1)";
  }

  return "rgba(254, 236, 238, 1)";
};

export const getBorderColor = (detailsType: Details_DetailsType): string => {
  if (detailsType === Details_DetailsType.INFO) {
    return "rgba(250, 250, 250, 1)";
  }

  if (detailsType === Details_DetailsType.WARNING) {
    return "rgba(255, 185, 56, 1)";
  }

  return "rgba(255, 87, 87, 1)";
};

export const StyledInfoSection = styled.div<{
  detailsType: Details_DetailsType;
}>`
  background-color: ${({ detailsType }) => getBackgroundColor(detailsType)};
  padding: 9px 15px 9px 15px;
  margin-bottom: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  border-left: 3px solid ${({ detailsType }) => getBorderColor(detailsType)};

  .info-right-side {
    padding-left: 15px;
  }
`;
